var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link_banner",on:{"click":_vm.onBannerClick}},[(_vm.isWide)?_c('img',{attrs:{"src":_vm.element.largeScreenImageUrl,"alt":_vm.element.title}}):_c('img',{attrs:{"src":_vm.element.imageUrl,"alt":_vm.element.title}})])}
var staticRenderFns = []

export { render, staticRenderFns }